module.exports = __webpack_public_path__ + "b446e39d7fc613ad4f4876c4e37a448d.pdf";